var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.data
      ? _c(
          "a",
          {
            staticClass: "news-card",
            attrs: {
              href: _vm.route(_vm.computedUrl, ..._vm.computedUrlParams),
            },
          },
          [
            _c("img", {
              staticClass: "dynamic-image",
              attrs: {
                "data-object-fit": "cover",
                src: _vm.data.afbeelding.guid,
                alt: `${_vm.data.title.rendered} | Vastgoed C`,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "content d-flex flex-column justify-content-between",
              },
              [
                _c("h4", {
                  domProps: { innerHTML: _vm._s(_vm.data.title.rendered) },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._f("truncate")(_vm.data.intro, 500, "..."),
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("button", { staticClass: "btn btn-cyan" }, [_vm._v("Lees meer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }